module.exports = __webpack_public_path__ + "img/asset6.0a9bb517.png";